import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FileItemDto } from '@common/generated-api/models/file-item-dto';
import { CommonFilesApiService } from '@common/generated-api/services/common-files-api.service';
import { AppService } from '@shared/services/app.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss'],
})
export class ImagePickerComponent implements OnInit {
  @Input() url: string;
  @Output() changed = new EventEmitter<FileItemDto>();
  @Output() removed = new EventEmitter<FileItemDto>();
  acceptTypes: string;
  fileInputControl = new UntypedFormControl(null);

  constructor(private appService: AppService, private commonFilesApiService: CommonFilesApiService) {}

  ngOnInit(): void {
    // if (!this.url) {
    //   this.url = 'assets/images/acc-'
    // }
  }

  onFilePicked(event: any) {
    const file = event.target.files[0];
    console.log(file);
    const stop = this.appService.startLoader();
    this.commonFilesApiService
      .upload({
        module: 'PROFILE',
        // entityName: file.name,
        // previewCompressionMode: 'TO_SIZE_500',
        body: { file },
      })
      .pipe(finalize(() => stop()))
      .subscribe({
        next: (data) => {
          this.url = data.result.url;
          console.log(data);
          this.changed.emit(data.result);
        },
      });
  }

  remove() {
    this.removed.emit();
    this.url = null;
    this.fileInputControl.reset(); // we need clear input, otherwise user cannot select the save file again
  }
}
